import React from 'react';
import { IconButton, Paper } from 'material-ui';
import TemplateIcon from 'material-ui/svg-icons/action/description';
import LightBulb from 'material-ui/svg-icons/action/lightbulb-outline';
import EmptyFile from 'material-ui/svg-icons/editor/insert-drive-file';
import ArrowCircleRight from 'material-ui/svg-icons/navigation/chevron-right';

const styles = {
  cardDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1em',
    width: '220px',
    cursor: 'pointer',
    transition: 'box-shadow 0.3s ease-in-out',
    borderRadius: '5px',
  },
  mainIcon: {
    height: '72px',
    width: '72px',
    color: 'rgba(0, 0, 0, 0.64)',
    display: 'block',
    transition: 'transform .3s ease-in-out',
  },
  arrowBtn: { border: '2px solid #00bcd4', borderRadius: '50%', color: '#00bcd4', height: '32px', width: '32px', transition: 'transform .3s ease-in-out' },
  cardTitle: { height: '72px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
  title: {
    fontSize: '13px',
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    fontWeight: 'bold',
  },
};

class OptionCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  onMouseEnter = () => this.setState({ hover: true });
  onMouseLeave = () => this.setState({ hover: false });
  render() {
    const {
      IconComp,
      title,
      subTitle,
      disabled,
      defaultPop,
      loadFromScrach,
      onClick,
    } = this.props;
    const { hover } = this.state;
    const highlight = hover && !disabled;
    const color = isIcon => {
      if (disabled) return 'rgba(0, 0, 0, 0.34)';
      if (highlight) return '#00bcd4';
      if (loadFromScrach) return 'rgba(0, 0, 0, 0.54)';
      return 'rgba(0, 0, 0, 0.64)';
    };
    return (
      <div
        style={{
          ...styles.cardDiv,
          ...(loadFromScrach ? {
            border: 'none',
          } : {}),
          boxShadow: (() => {
            if (highlight) return '0 10px 35px rgba(0,0,0,0.2)';
            if (defaultPop) return '0 5px 15px rgba(0,0,0,0.35)';
            return '0 0 0 rgba(0,0,0,0.15)';
          })(),
          backgroundColor: loadFromScrach ? '#fff' : '#00bcd41f',
        }}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={onClick}
      >
        <IconComp style={{ ...styles.mainIcon, transform: highlight ? 'scale(1.2)' : 'none', color: color(true) }}/>
        <div style={{ ...styles.cardTitle, color: color(false) }}>
          <div style={styles.title}>
            {title}
          </div>
          <small
            style={{ visibility: subTitle ? 'visible' : 'hidden', fontSize: '11px' }}
          >
            {subTitle}
          </small>
        </div>
        <IconButton iconStyle={{ ...styles.arrowBtn, transform: highlight ? 'scale(1.2)' : 'none', color: color(true), borderColor: color(true) }}>
          <ArrowCircleRight/>
        </IconButton>
      </div>
    );
  }
}

const TemplateOptions = props => {
  const {
    templates,
    templatesForCC,
    docId,
    style,
    goToOmniImport,
    goToImportOwn,
  } = props;
  const filteredCCList = templatesForCC.filter(o => o.originalContractId !== docId);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', ...style }}>
      <OptionCard
        defaultPop={Boolean(templates.length)}
        IconComp={TemplateIcon}
        disabled={!Boolean(templates.length)}
        title="Your Rate Sheets"
        subTitle={`(${templates.length} found)`}
        onClick={goToImportOwn}
      />&nbsp;&nbsp;
      <OptionCard
        defaultPop={!templates.length}
        IconComp={LightBulb}
        title={`TourConnect\nRate Sheets Database`}
        subTitle={filteredCCList.length ? `(${filteredCCList.length} found)` : ''}
        onClick={goToOmniImport}
      />
    </div>
   );
};

const ImportOptions = props => {
  const {
    forNewDraft,
    templates,
    templatesForCC,
    docId,
    goToOmniImport,
    goToImportOwn,
    onRequestClose,
  } = props;
  if (forNewDraft) {
    // 2px solid #00bcd45
    return (
      <div className="flex-center">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: 'none' }}>
          <h4 style={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.44)' }}>Import</h4>
          <TemplateOptions
            style={{ borderTop: 'none' }}
            templates={templates}
            templatesForCC={templatesForCC}
            docId={docId}
            goToOmniImport={goToOmniImport}
            goToImportOwn={goToImportOwn}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '1em', border: 'none' }}>
          <h4 style={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.44)' }}>Load from Scratch</h4>
          <div style={{ borderTop: 'none' }}>
            <OptionCard
              loadFromScrach
              IconComp={EmptyFile}
              title="Blank Rate Sheet"
              onClick={onRequestClose}
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <TemplateOptions
      style={{ justifyContent: 'space-between', width: '60%', margin: '1em auto' }}
      templates={templates}
      templatesForCC={templatesForCC}
      docId={docId}
      goToOmniImport={goToOmniImport}
      goToImportOwn={goToImportOwn}
    />
  );
};

export default ImportOptions;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/import-template/import-options.jsx